import {
    fetchActiveNotifications,
    Notification,
    postMarkNotificationsUnread,
} from "./api";
import {AppDispatch} from "../configureStore";

export const getNotifications = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const notifications = await fetchActiveNotifications()
            dispatch(setNotifications(notifications))
        } catch (e) {
            console.error(e)
        }
    }
}

export const setNotifications = (notifications: Notification[]) => ({
    type: 'SET_NOTIFICATIONS',
    notifications
})

export const markNotificationsUnreadAction = () => {
    return async (dispatch: AppDispatch) => {
        await postMarkNotificationsUnread()
        dispatch(markNotificationUnread())
    }
}

export const markNotificationUnread = () => ({
    type: 'MARK_NOTIFICATIONS_UNREAD',
})